export enum CfmResponseFieldType {
  Text = "text",
  TextArea = "text_area",
  Number = "number",
  FloatingPoint = "floating_point",
  Date = "date",
  File = "file",
}
